export const getUserName = (currentEmail, approvedUsers) => {
  let isValid = false;
  approvedUsers.forEach((element) => {
    if (element.email === currentEmail) isValid = {currentUserId: element.id, userName: element.name};
  });
  if (isValid) return isValid;
  else return false;
};
